import UploadedRequestedDocument from './UploadedRequestedDocument.component';

export default UploadedRequestedDocument;